import React from 'react';
import LogoImage from '../../assets/images/lv-logo.svg';
import styles from './Logo.module.css';
import {Link} from 'react-router-dom';

const Logo = (props) => (
  <Link to="/">
    <div className={styles.logo}>
      <img src={LogoImage} alt="LeadVenture Marketing" />
    </div>
  </Link>
);

export default Logo;
